// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__2IqGo","dragIcon":"SortableItem_dragIcon__ytbBV","disabled":"SortableItem_disabled__7SkZV"};